'use client';

import { Switch } from '@coolblue-development/freddy';
import seeOnlyDifferencesOffTrigger from '@coolblue-development/ga4-events/triggers/ComparisonTool/seeOnlyDifferencesOffTrigger';
import seeOnlyDifferencesOnTrigger from '@coolblue-development/ga4-events/triggers/ComparisonTool/seeOnlyDifferencesOnTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import { useState } from 'react';

import { StyledOnlyShowDifferencesSwitch } from './OnlyShowDifferencesSwitch.styled';

const OnlyShowDifferencesSwitch = () => {
  const [checked, setChecked] = useState(() => false);

  const { trackEvent } = useAnalytics();
  const { t } = useTranslation('webshop');

  function sendTrackingEventAndSetChecked(isChecked: boolean) {
    if (isChecked) {
      trackEvent(seeOnlyDifferencesOnTrigger());
    } else {
      trackEvent(seeOnlyDifferencesOffTrigger());
    }

    setChecked(isChecked);
  }

  return (
    <StyledOnlyShowDifferencesSwitch
      className={`only-show-differences${checked ? ' checked' : ''}`}
    >
      <Switch
        label={t('compare.onlyShowDifferences')}
        checked={checked}
        onChange={sendTrackingEventAndSetChecked}
      />
    </StyledOnlyShowDifferencesSwitch>
  );
};

export { OnlyShowDifferencesSwitch };
